import { memo, useMemo } from 'react';
import { Badge, useMantineTheme, useComputedColorScheme } from '@mantine/core';

interface DataBadgeProps {
  children: any;
  customStyle?: object;
  onClick?: () => void;
}

export const DataBadge: React.FC<DataBadgeProps> = memo(
  ({ children, customStyle = undefined, onClick = () => {} }) => {
    const theme = useMantineTheme();
    const computedColorScheme = useComputedColorScheme('dark');
    const color = useMemo(() => {
      return theme.colors[`secondary-${computedColorScheme}`][0];
    }, [theme, computedColorScheme]);

    const memoizedOnClick = useMemo(() => onClick, [onClick]);
    const memoizedStyle = useMemo(() => ({ ...customStyle }), [customStyle]);

    return (
      <Badge
        radius="sm"
        color={color}
        c={computedColorScheme === 'dark' ? theme.colors.dark[9] : 'white'}
        onClick={memoizedOnClick}
        style={memoizedStyle}
      >
        {children}
      </Badge>
    );
  }
);
